<div class="chip" ngClass="{{class}}">
  <mat-icon fontSet="material-icons-round" class="icon" color="white" *ngIf="icon?.type !== 'checkmark' && icon?.type">{{icon.type}}</mat-icon>
  <mat-icon class="app-accept-icon" color="white"  *ngIf="icon?.type === 'checkmark'">check</mat-icon>
  <svg *ngIf="dot" class="dot" viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg" [style]="{fill: dot}">
    <circle cx="5px" cy="5px" r="5px" />
  </svg>
  <span class="klabel-medium">{{ text }}</span>
  <mat-icon fontSet="material-icons-round" *ngIf="closable" class="close-icon" (click)="close()">close</mat-icon>
</div>